/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { ComplianceStatus } from "~/features/myAccount/constants";
import { GetComplianceStatusResponseData } from "~/features/myAccount/types";

const transformToComplianceStatus = (statusData: GetComplianceStatusResponseData): ComplianceStatus => {
  if (typeof statusData.status === "number" && ComplianceStatus[statusData.status]) {
    return statusData.status;
  }

  return ComplianceStatus.NOT_FOUND;
};

export default transformToComplianceStatus;
